import "./style.scss";
import SpecialEvents from "./Components/SpecialEvents/SpecialEvents";
import Availability from "./Components/Availability/Availability";
import AvailabilitySelections from "./Components/AvailabilitySelections/AvailabilitySelections";
import Home from "./Components/Home/Home";
import EditEventsPage from "./Components/AdminControls/SpecialEventsControls/EditEvents/EditEvents";
import SEBulkUpdateEventPage from "./Components/AdminControls/EventParentControls/BulkUpdateEvent/SEBulkUpdateEventsPage";
import axios from "axios";
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "./Components/Login/Login";
import Tiles from "./Components/Tiles/Tiles";
import { useEffect, useState } from "react";
import { personActions, workScheduleActions,ODSFutureActions } from "./store/store";
import { urlActions } from "./store/store";
import store from "./store/store";
import { constants, environmentVariables } from "./Shared/Url/Constants";
import ErrorPage from "./Components/ErrorPage/ErrorPage";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import SpecialEventsDetail from "./Components/SpecialEvents/SpecialEventsDetail";
import { logout } from './Shared/Utill/AuthUtil';
import { object } from "underscore";
import { useJwt, isExpired, decodeToken } from "react-jwt";
import axiosInstance from "./Shared/Utill/AxiosConfig";
import AdminControlsPage from "./Components/AdminControls/AdminControls";
import AppControlsOnOff from "./Components/AdminControls/AppControlsOnOff";
import { personStaticActions } from "./store/store";
import SpecialEventsControlsPage from "./Components/AdminControls/SpecialEventsControls/SpecialEventsControls";
import EventDetailsPage from "./Components/AdminControls/SpecialEventsControls/SearchEvents/Event Details/EventDetails";
import SESearchEventsPage from "./Components/AdminControls/SpecialEventsControls/SearchEvents/SESearchEventsPage";
import SEAddEventsPage from "./Components/AdminControls/SpecialEventsControls/AddEvents/SEAddEventsPage";
import SearchParentEventControlPage from "./Components/AdminControls/EventParentControls/SearchEventControl/SearchParentEventControlPage";
import AvailabilityAppControlsTiles from "./Components/AdminControls/AvailabilityAppControls/AvailabilityAppControlsTiles"
import RuleAssignmentsSearch from "./Components/AdminControls/AvailabilityAppControls/RuleAssignments/Search/RuleAssignmentsSearch";
import AddEditWorkScheduleGrouping from "./Components/AdminControls/AvailabilityAppControls/WorkScheduleGrouping/AddEditWorkScheduleGrouping";
import WorkScheduleGrouping from "./Components/AdminControls/AvailabilityAppControls/WorkScheduleGrouping/WorkScheduleGrouping"
import AddEditRuleAssignments from "./Components/AdminControls/AvailabilityAppControls/RuleAssignments/AddEdit/AddEditRuleAssignment";
import PreferenceGroupsSearch from "./Components/AdminControls/AvailabilityAppControls/Preference Groups/PreferenceGroupsSearch";
import AddEditPreferenceGrouping from "./Components/AdminControls/AvailabilityAppControls/Preference Groups/AddEditPreferenceGrouping";
import AdvanceSearch from "./Components/AdminControls/AvailabilityAppControls/AdvanceSearch"
import RulesSearch from "./Components/AdminControls/AvailabilityAppControls/Rules/Search/RulesSearch";
import RulesAddEdit from "./Components/AdminControls/AvailabilityAppControls/Rules/AddEdit/AddEditRule"
import LocationControlsSearch from "./Components/AdminControls/AvailabilityAppControls/Location Controls/LocationControlsSearch";
import AddEditLocationControls from "./Components/AdminControls/AvailabilityAppControls/Location Controls/AddEditLocationControls";
import CutOffCalendarSearch from "./Components/AdminControls/AvailabilityAppControls/CutOffCalendar/CutOffCalendarSearch";
import SearchAccommodation from "./Components/AdminControls/Accommodations/Search/SearchAccommodation";
import AddEditAccomodations from "./Components/AdminControls/Accommodations/AddEdit/AddEditAccomodations";
import moment from "moment";
import BulkAdd from "./Components/AdminControls/SpecialEventsControls/BulkAdd/BulkAdd";
import { Loader } from "@genesis/ui-kit";


function App() {
  const [email, setEmail] = useState("");
  const [authStatus, setAuthStatus] = useState(true); //PLZ RUN ON QA MAN PLZ TODo:/ run locally set default value of authStatus to true
  const personDetails = useSelector((state) => state.person.personData);
  const personStaticDetails = useSelector((state) => state.personStatic.personStaticData);
  const urlDetails = useSelector((state) => state.url.urlData);
  const [urlLocalState,setUrlLocalState] = useState();
  const colleagueID = Cookie.get("colleagueID");
  const colleagueTKN = Cookie.get('X_TKN');
  const env_variable = Cookie.get('env-variable');
  const nameId = Cookie.get("nameId");
  const nameIDFormat = Cookie.get("nameIdFormat");
  const sessionIndex = Cookie.get("sessionIndex");
  const tkn_validity = useJwt(colleagueTKN);
  const navigate = useNavigate();
  if(environmentVariables.envLevel === "LOCAL"){
  Cookie.set("X_TKN", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lSUQiOiIwNzUyMjQ2NyIsIm5hbWVJREZvcm1hdCI6InVybjpvYXNpczpuYW1lczp0YzpTQU1MOjEuMTpuYW1laWQtZm9ybWF0OnVuc3BlY2lmaWVkIiwiY29sbGVhZ3VlSUQiOiIwNzUyMjQ2NyIsImlhdCI6MTcwNDI2NDA3OCwiZXhwIjoxNzA0MjY1ODc4fQ.vUZx1UjphMmue1iYc7Yj5XQNHA6-K-cOTkMN6Qhfj_8");
  }
  const [validODSWS, setvalidODSWS] = useState(false); // TODo:/ run locally set default value of authStatus to true

 
  useEffect(() => {
    if (environmentVariables.envLevel === "LOCAL"){
      getApiUrlsLocal();
    } else {
      getApiUrls();
      console.log("after getapiurls ",JSON.stringify(urlLocalState))
    }
  },[])

  useEffect(() => {
    console.log("2nd use effect" ,JSON.stringify(urlLocalState))
  },[urlLocalState])

  const getEmpWSAndPersonDetails = (passedUrls) =>{
    console.log("we never get here after getApiUrls call?")
    console.log("checkpoint",JSON.stringify(passedUrls));
    if (
      (personDetails.impersonate_admin_id === null ||
      personDetails.impersonate_admin_id === undefined) && (Object.keys(urlDetails).length > 0 || Object.keys(passedUrls).length > 0 ) 
    ) {
      console.log("we never get here after getApiUrls call? 2")
      if ((colleagueID !== undefined && ((urlDetails.uiEnvUrls!== undefined) && Object.keys(urlDetails.uiEnvUrls).length > 0) ) ||(colleagueID !== undefined && Object.keys(passedUrls).length > 0)  || environmentVariables.envLevel === "LOCAL") {
        console.log("TTTUseEffect Appjs If condition true");
        if(environmentVariables.envLevel === "LOCAL"){
          //:new changes with ODS calls and Redux 
             getODSFutureandSaveToRedux("01011146");  //07523184
         }else{
          console.log("we never get here after getApiUrls call? (ods future)")
           getODSFutureandSaveToRedux(colleagueID,passedUrls);  
         }
         console.log("we never get here after getApiUrls call? (person)")
         getPerson(passedUrls);
      } else {
        console.log("we never get here after getApiUrls call? (redirect)")
        RedirectToLogin()
      }
      
    } else {
      console.log("This is why the code stopped")
    }

  }

  const getApiUrls = () => {
    try {
      store.dispatch(urlActions.resetUrlState());
      //: base url from urlDetails instead of window location
      let homeURL = window.location.protocol + "//" + window.location.hostname + "/"
      console.log("This is the url im using to call getui: ",homeURL)
      let url = `${homeURL}${constants.WFM_GET_UI_ENV_URLS}`
      console.log("Current: ", urlDetails)
       
      const response = axios.get(url) 
       .then((response) => {
        if (response.status == 200) {
          let data = response.data;
          let urlWorkAround = {uiEnvUrls: data};
          console.log("Server Side Helm Chart ENV Variables: ",data)
          setUrlLocalState({ uiEnvUrls: data });
          store.dispatch(
            urlActions.setUrlState({ uiEnvUrls: data })
          );
          
          
            
        // Proceed with further functionality once we get the urls
        getEmpWSAndPersonDetails(urlWorkAround);
        } 
      }) 
       
    } catch (error) {
      let homeURL = window.location.href
      navigate("/somethingwentwrong", {state:`${homeURL}...failed`});
    }
  } 

  const getApiUrlsLocal = () => {
    store.dispatch(
      urlActions.resetUrlState()
    )
    let homeURL = window.location.href
    setUrlLocalState({ uiEnvUrls: {"REACT_APP_WFM_WFMCOMMON_BASE_URL": "https://wfmcommondev.macys.net/WFMCommon/v1/",
    "REACT_APP_WFM_AVAILABILITY_UI_BASE_URL": "https://availability-dev-ui.cloudrts.net/",
    "REACT_APP_WFM_AVAILABILITY_API_BASE_URL": "https://availability-dev-api.cloudrts.net/",
    "REACT_APP_WFM_AVAILABILITY_PTO_URL": "https://hfadev/insitedev/pto/absence_mgmt.aspx",
    "REACT_APP_WFM_AVAILABILITY_MSP_COMMS": "https://hfadev/insitedev/fas/my_schedule_plus_communications.aspx",
    "REACT_APP_WFM_AVAILABILITY_TIMEOFF": "https://hr.macys.net/csw/s/pub/pdfs/14537.pdf",
    "REACT_APP_WFM_AVAILABILITY_ENV": "DEV",
    "REACT_APP_WFM_AVAILABILITY_AVL_QRC":"https://hr.macys.net/csw/s/pub/pdfs/14537.pdf",
    "REACT_APP_WFM_AVAILABILITY_SEA_QRC":"https://hr.macys.net/csw/s/pub/pdfs/14537.pdf",
    "REACT_APP_COMMON_SVC":"http://qa-location-service-k8s.devops.fds.com/v1/",  
    "testingmypatience":"keepmovingforward8"}  });
    store.dispatch(
      urlActions.setUrlState({ uiEnvUrls: {
        "REACT_APP_WFM_WFMCOMMON_BASE_URL": "https://wfmcommondev.macys.net/WFMCommon/v1/",
        "REACT_APP_WFM_AVAILABILITY_UI_BASE_URL": "https://availability-dev-ui.cloudrts.net/",
        "REACT_APP_WFM_AVAILABILITY_API_BASE_URL": "https://availability-dev-api.cloudrts.net/",
        "REACT_APP_WFM_AVAILABILITY_PTO_URL": "https://hfadev/insitedev/pto/absence_mgmt.aspx",
        "REACT_APP_WFM_AVAILABILITY_MSP_COMMS": "https://hfadev/insitedev/fas/my_schedule_plus_communications.aspx",
        "REACT_APP_WFM_AVAILABILITY_TIMEOFF": "https://hr.macys.net/csw/s/pub/pdfs/14537.pdf",
        "REACT_APP_WFM_AVAILABILITY_ENV": "DEV",
        "REACT_APP_WFM_AVAILABILITY_AVL_QRC":"https://hr.macys.net/csw/s/pub/pdfs/14537.pdf",
        "REACT_APP_WFM_AVAILABILITY_SEA_QRC":"https://hr.macys.net/csw/s/pub/pdfs/14537.pdf", 
        "REACT_APP_COMMON_SVC":"http://qa-location-service-k8s.devops.fds.com/v1/", 
        "testingmypatience":"keepmovingforward8"

    }  })
    );
     // Proceed with further functionality once we get the urls
     // for local
     //  getEmpWSAndPersonDetails(urlLocalState);  

     getEmpWSAndPersonDetails();  

    
  } 

  const getPerson = (passedUrls) => {
    let urlCheck = Object.keys(urlDetails).length > 0
    return new Promise((resolve, reject) =>{
      try {
        let urls = urlDetails.uiEnvUrls;
        store.dispatch(personActions.resetPersonState());
        console.log("These are the helmChart Urls: ",urls)
        let url = "";
      if (environmentVariables.envLevel === "LOCAL"){
      url ='https://wfmcommondev.macys.net/WFMCommon/v1/person/01011146'  //10011802 //01005505 //07523184      
      } else if(urlCheck) {
        url =
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_PERSON}/${colleagueID}`;
      } else{
        url =
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_PERSON}/${colleagueID}`;
      }
        const response = axiosInstance
          .get(url,
          {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + colleagueTKN,
              }
          })
          .then((response) => {
            if (response.status === 200) {
              let cookies = {
                posting_ID:colleagueID,
                posting_TKN:colleagueTKN
              }
              console.dir(response.data);
              let data = response.data;
              // update the static value for person which will not change
              store.dispatch(personStaticActions.setPersonStaticState({ ...data }));

              store.dispatch(personActions.setPersonState({ ...data }));
              store.dispatch(
                personActions.setPersonState({ impersonate_admin_id: null})
              );
              //maintain cokkies in person static for route logic
              store.dispatch(personStaticActions.setPersonStaticState({...cookies}));

              store.dispatch(
                personActions.setPersonState({...cookies})
              );
             
             
            } 

          }) 

          .catch((error) => {

        

            navigate("/somethingwentwrong", {state:`${urlDetails.uiEnvUrls.WFM_AVAIL_PERSON}...failed`});
      
          }); // response catch

      } catch (error) {} // catch

    })

  };

  //new changes with ODS calls and Redux 
  const getODSFutureandSaveToRedux = (empId,passedUrls) => {
    let urlCheck = Object.keys(urlDetails).length > 0;
    console.log("urlCheck value is ",urlCheck)
    let url = "";
    if (urlCheck) {
      url =
      `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${empId}`;
    } else {
      url =
      `${passedUrls.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${empId}`;
    }
   return new Promise((resolve, reject) =>{
// calling this to fix the work schedule. Whenever impersonate is done need to update work schedule
  axiosInstance.get( url, {
    headers: {
      'content-type': 'application/json',
      'Authorization': 'Bearer ' + colleagueTKN
    }
  })
  .then((response) => {
    store.dispatch(ODSFutureActions.resetODSFutureState());
   console.log("response is",response.data)
   if (response.data.length === 0){
    console.log("EMPTY WS");
    store.dispatch(ODSFutureActions.resetODSFutureState());
    navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
    return;
   }
   let data = response.data;
   // check this whether we ccan get multiple record or not
   const filterByExpiration = () => data.filter(({ adjstddate }) => new Date(adjstddate) <= new Date());
    let filter = filterByExpiration();
    var max = filter.length > 0 ? filter.reduce(function (a, b) { return a.adjstddate > b.adjstddate ? a : b; }) : null;
   store.dispatch(ODSFutureActions.setODSFutureState({...max}));
   if(Object.keys(max).length === 0){
    setvalidODSWS(false);
    }else{
      setvalidODSWS(true);
    } 
   
  })
  .catch((error) => {
    
    console.error("This is an issue "+error)
     if(error.message === 'Network Error') {
      navigate("/somethingwentwrong", {state:`Please logout and try again `})
    } else if (error.message === 'Empty workSchedule') {
      let data= {};
      store.dispatch(ODSFutureActions.resetODSFutureState());
      navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
    } else {
      navigate("/somethingwentwrong", {state:`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${empId}...failed`})
      } 
  }) 

});
  }
  
  const redirectToLogout = () => {
    logout(true)
  }

  // If the urlDetails object is empty do redirect based on current page
  // Otherwise use urls saved in state store
  const RedirectToLogin = () => {
      if (colleagueID === undefined) {
        const homeURL = window.location.protocol + "//" + window.location.hostname
        window.location.replace(`${homeURL}/login` );
      } else {
        console.log("using urlDetails redirect")
       const homeUrl = window.location.protocol + "//" + window.location.hostname
       window.location.replace(`${homeUrl}/` );
      }
      
    }
  
  const authStatusCheck = (flag) => {
    setAuthStatus(flag); /*This code handles the scenario when the flip to allow a user access to home.js
    comes before person details redux is filled. Which is what caused our white screen issue. With this conditional
    reload, we are able to get passed that issue*/ 
    if ((Object.keys(urlDetails).length!==0)) {
      if (Object.keys(personDetails).length===0) {
        console.log("Debugging person details(redux)" ,Object.keys(personDetails).length===0)
        //window.location.reload()
      }
      console.log("Debugging is fun")
      
    }
    
    
    //reload on firefox and safari browser after login due to blank page NS_BINDING_ABORT issue
    /*let isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
    let isSafari = isSafariBrowser();
    if(isFirefox || isSafari) {
      console.log("Firefox detected : reload Firefox"+ isFirefox + "Safari "+ isSafari );
      window.location.reload();
    }*/
  };

  function isSafariBrowser(){
    var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;
      if (is_safari){
          if (is_chrome)  // Chrome seems to have both Chrome and Safari userAgents
              return false;
          else
              return true;
      }
      return false;
  }

  const emailCheck = (mail) => {
    setEmail(mail);
  };

  return ( 
    <div className="App">
      <Routes>
          <Route path="/" element=
          {
          (
            (authStatus) && (colleagueTKN !==undefined ||environmentVariables.envLevel === "LOCAL") ? 
            ( (Object.keys(urlDetails).length > 0) || ( (urlLocalState!== undefined) && ( Object.keys(urlLocalState).length > 0 ) )  ? 
            ( personDetails && ((Object.keys(personDetails).length > 1)) ) && urlDetails  && <Home urlLocalState = {urlLocalState} redirectToLogout = {redirectToLogout} /> : <div>Loading.. please wait!</div> ) :  (
              <Login
                authStatusFun = {authStatusCheck}
                emailFun = {emailCheck}
                redirectFun = {RedirectToLogin}
                colleagueId = {colleagueID}
              />
              )
          ) 
          }>
            <Route index element={
            personDetails.impersonate_admin_id !== undefined ? // if impersonate is not undefined then check
            environmentVariables.envLevel === "LOCAL"  ? <Tiles urlLocalState = {urlLocalState}/> :
            personStaticDetails.posting_TKN!==undefined ? <Tiles urlLocalState = {urlLocalState} /> : null    // if posting_TKN is undefined return null
            : null} />
            <Route path="/specialevents" element={<SpecialEvents />} />
            <Route
              path="specialevents/details"
              element={<SpecialEventsDetail />}
            />
            <Route path="availabilityselections" element={<AvailabilitySelections />} />
            <Route path="availability" element={<Availability />} />
            <Route path="*" element={<ErrorPage />} />
            <Route path="somethingwentwrong" element={<ErrorPage />} />
            <Route path="controls" element={<AdminControlsPage/>} />
            <Route path="controls/apponoff" element={<AppControlsOnOff/>} />
            <Route path="controls/specialeventscontrols" element={<SpecialEventsControlsPage/>} />
            <Route path="controls/specialeventscontrols/searchevent" element={<SESearchEventsPage/>} />
            <Route path="controls/specialeventscontrols/searchevent/EventDetails" element={<EventDetailsPage/>} />
            <Route path="controls/specialeventscontrols/eventcontrols" element={<SearchParentEventControlPage/>} />
            <Route key="add-events" exact path="controls/specialeventscontrols/eventcontrols/Add" element={<EditEventsPage key="add-events"/>} />
            <Route key="edit-events" exact path="controls/specialeventscontrols/eventcontrols/Edit" element={<EditEventsPage key="edit-events"/>} />
            <Route path="controls/specialeventscontrols/eventcontrols/BulkUpdate" element={<SEBulkUpdateEventPage/>} />
            <Route path="controls/availabilityapplicationcontrols" element={<AvailabilityAppControlsTiles/>} />
            <Route path="controls/availabilityapplicationcontrols/workschedulegrouping" element={<WorkScheduleGrouping/>} />
            <Route path="controls/availabilityapplicationcontrols/workschedulegrouping/Add" element={<AddEditWorkScheduleGrouping/>} />
            <Route path="controls/availabilityapplicationcontrols/workschedulegrouping/Edit" element={<AddEditWorkScheduleGrouping/>} />
            <Route path="controls/availabilityapplicationcontrols/ruleassignments" element={<RuleAssignmentsSearch/>} />
            <Route path="controls/availabilityapplicationcontrols/ruleassignments/Add" element={<AddEditRuleAssignments/>} />
            <Route path="controls/availabilityapplicationcontrols/ruleassignments/Edit" element={<AddEditRuleAssignments/>} />
            <Route path="controls/availabilityapplicationcontrols/advancesearch" element={<AdvanceSearch/>} />
            <Route path="controls/availabilityapplicationcontrols/rules" element={<RulesSearch/>} />
            <Route path="controls/availabilityapplicationcontrols/rules/Add" element={<RulesAddEdit/>} />
            <Route path="controls/availabilityapplicationcontrols/rules/Edit" element={<RulesAddEdit/>} />
            <Route path="controls/availabilityapplicationcontrols/rules/Duplicate" element={<RulesAddEdit/>} />
            <Route path="controls/availabilityapplicationcontrols/locationcontrols" element={<LocationControlsSearch/>} />
            <Route path="controls/availabilityapplicationcontrols/locationcontrols/Add" element={<AddEditLocationControls/>} />
            <Route path="controls/availabilityapplicationcontrols/locationcontrols/Edit" element={<AddEditLocationControls/>} />
            <Route path="controls/availabilityapplicationcontrols/locationcontrols/Duplicate" element={<AddEditLocationControls/>} />
            <Route path="controls/availabilityapplicationcontrols/cutoffcalendar" element={<CutOffCalendarSearch/>} />
            <Route path="accommodation" element={<SearchAccommodation />} />
            <Route path="accommodation/Addaccomodation" element={<AddEditAccomodations />} />
            <Route path="accommodation/Edit" element={<AddEditAccomodations />} />
            <Route path="controls/specialeventscontrols/bulkadd" element={<BulkAdd/>} />
          </Route>
      </Routes>
    </div>
  );
}

export default App;


